import { useState, useEffect, useCallback } from 'react';
import { BREAKPOINTS, gridColumns, pickBreakpoint, getScreenTier } from '../utils/responsive';

export const useWindowSize = () => {
  const [size, setSize] = useState({
    width: typeof window !== 'undefined' ? window.innerWidth : 1024,
    height: typeof window !== 'undefined' ? window.innerHeight : 768,
  });

  useEffect(() => {
    const handler = () => setSize({
      width: window.innerWidth,
      height: window.innerHeight,
    });
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);

  const width = size.width;
  const isMobile = width < BREAKPOINTS.mobile;
  const isTablet = width >= BREAKPOINTS.mobile && width < BREAKPOINTS.layoutDesktop;
  const isDesktop = width >= BREAKPOINTS.layoutDesktop;
  const screenTier = getScreenTier(width);
  const isPhone = width < BREAKPOINTS.phone;       // < 480px
  const isSmallMobile = width < BREAKPOINTS.mobile; // < 768px (same as isMobile — alias)
  const isLargeDesktop = width >= BREAKPOINTS.desktop; // ≥ 1440px

  /** Phones + tablets — top bar + side drawer (no bottom bar); desktop uses sidebar */
  const useMobileNav = !isDesktop;

  const pick = useCallback(
    (mobile, tablet, desktop) => pickBreakpoint(width, { mobile, tablet, desktop }),
    [width],
  );

  const gridCols = useCallback(
    (mobile, tablet, desktop) => gridColumns(width, mobile, tablet, desktop),
    [width],
  );

  return {
    width,
    height: size.height,
    isMobile,
    isTablet,
    isDesktop,
    screenTier,
    isPhone,
    isLargeDesktop,
    useMobileNav,
    /** @deprecated Use isMobile for phone-only UI, or pick()/gridCols() for 3-tier layouts */
    isSmall: isMobile,
    pick,
    gridCols,
  };
};
